import React from "react";
import SectionHeader from "../../common/sectionTitle";

const ProductList = ({ products, label, action = null }) => {
  return (
    <>
      <SectionHeader title={label} action={action} withLine />
      <ul className="products">
        {Array.isArray(products) && products.length > 0 ? (
          products.map((item) => (
            <li onClick={() => action.clickEvent()}>
              <img src={imgHandler(item.media)} onError={(e) => (e.target.src = "/img/logo.png")} />
              <strong>{item.productName}</strong>
              <span>{formatNumber(item?.totalPrice || item?.productPrice)}원</span>
            </li>
          ))
        ) : (
          <li className="not">{chooseParticle(label, "이가")} 존재하지 않습니다.</li>
        )}
      </ul>
    </>
  );
};

export default ProductList;
